import { IUpdatedFilters } from '@/creditflowresearch/application/League/Scorecard/types';
import { IColumnState, ISelectedPeriod } from '@/creditflowresearch/application/League/interfaces';
import { ICompanyByViewIdResponse } from '@/creditflowresearch/domain/vo/ICompany';

export const getTableIndex = (
  tableIndex: number,
  tableColumnCount: number,
  lengthOfPeriods: number,
): number => {
  const countPeriodCellDiff = (tableIndex + tableColumnCount) - lengthOfPeriods;

  if (countPeriodCellDiff > 0) {
    return tableIndex - countPeriodCellDiff;
  }

  return tableIndex;
};

export const createPeriodFilters = (
  payload: { dateFrom: number, dateTo: number, categoryId: string, subCategoryId: string },
  type: string,
) => ({
  dateFrom: payload.dateFrom,
  dateTo: payload.dateTo,
  [type]: {
    [`${ type }Id`]: payload.categoryId,
    [`sub${ type }Id`]: payload.subCategoryId,
  },
} as unknown as IUpdatedFilters);

export const createResetFilters = () => ({
  dateFrom: null,
  dateTo: null,
} as unknown as IUpdatedFilters);

export const createResetPeriod = (): ISelectedPeriod => ({
  categoryId: null,
  subCategoryId: null,
  name: '',
  dateFrom: null,
  dateTo: null,
});

export const createInitialColumnState = (): IColumnState => ({
  valueTableIndex: 0,
  valueTableColumnCount: 4,
  rankTableIndex: 0,
  rankTableColumnCount: 4,
});

export const createInitialCompanyData = () => ({
  id: null,
  viewId: null,
  name: '',
} as unknown as ICompanyByViewIdResponse);
